module.exports = "module.exports = __webpack_public_path__ + \"static/media/pageFooter.be68a974.template\";"